var TelemetryServiceEvent = /* @__PURE__ */ ((TelemetryServiceEvent2) => {
  TelemetryServiceEvent2["Report"] = "telemetry-service:report";
  TelemetryServiceEvent2["UpdateMeta"] = "telemetry-service:update-meta";
  TelemetryServiceEvent2["ReportText"] = "telemetry-service:report-text";
  TelemetryServiceEvent2["Flush"] = "telemetry-service:flush";
  return TelemetryServiceEvent2;
})(TelemetryServiceEvent || {});
var TelemetryServiceOutgoingEvent = /* @__PURE__ */ ((TelemetryServiceOutgoingEvent2) => {
  TelemetryServiceOutgoingEvent2["BeforeClose"] = "telemetry-service:before-close";
  TelemetryServiceOutgoingEvent2["BeforeFlush"] = "telemetry-service:before-flush";
  return TelemetryServiceOutgoingEvent2;
})(TelemetryServiceOutgoingEvent || {});
export {
  TelemetryServiceEvent,
  TelemetryServiceOutgoingEvent
};
